/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Component imports.
 */
import { SeeMoreComponent } from './see-more/see-more.component';
import { HighlightPipe } from 'projects/ngp-docquity-ds/src/lib/pipes/highlightSearchText/highlight.pipe';

/**
 * This module contains the shared things.
 */
@NgModule({
  declarations: [
    SeeMoreComponent,
    HighlightPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SeeMoreComponent,
    HighlightPipe
  ]
})
export class ShareModule { }
